var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIc24Facebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  fillRule: "evenodd",
  d: "M15.174 5.32H17V2.14A23.663 23.663 0 0 0 14.34 2c-2.632 0-4.435 1.656-4.435 4.7v2.8H7v3.555h2.905V22h3.56v-8.945h2.789l.443-3.555h-3.231V7.05c0-1.027.276-1.73 1.708-1.73Z",
  clipRule: "evenodd"
})));
export default SvgIc24Facebook;